import React from "react";
import DataTable from "react-data-table-component-with-filter";
import {
  customDataTableStyles,
  defaultPageLimit,
  defaultRowsPerPageOptions,
} from "../../../Helper/Constants";

const IsrActivationList = (props) => {
  console.log(props.data);
  return (
    <div className="col-md-12 mt-5 customized-data-table-isr position-relative">
      <DataTable
        columns={props.columns}
        data={props.data}
        pagination
        striped
        highlightOnHover
        paginationRowsPerPageOptions={defaultRowsPerPageOptions}
        paginationPerPage={defaultPageLimit}
        customStyles={customDataTableStyles}
        //defaultSortFieldId={5}
        defaultSortAsc={false}
      />
    </div>
  );
};

export default IsrActivationList;
